export function setSession(key, value) {
    sessionStorage.setItem(key, JSON.stringify(value))
}
export function getSession(key) {
    return JSON.parse(sessionStorage.getItem(key))
}
/**
 * 使用
 * // 从sessionStorage删除保存的数据
sessionStorage.removeItem('key');
 
// 从sessionStorage删除所有保存的数据
sessionStorage.clear();
 */


// WEBPACK FOOTER //
// ./src/utils/session.js